export default /* graphql */ `
fragment homepageSection on HomepageSection {
  __typename
  sys { id }
  title
  slug
  headline
  headlineSize
  eyebrow
  copy {
    json
  }
  clipStyle
  backgroundImage {
    sys { id }
    title
    url(transform: {
      width: 1440,
      format: JPG,
      quality: 90
    })
  }
  backgroundImageMobile {
    sys { id }
    title 
    url(transform: {
      height: 800,
      format: JPG,
      quality: 90
    })
  }
  callToAction {
    ...link
  }
  callToActionGtmClass
  videoCard {
    title
    slug
    copy
    video
    thumbnail {
      sys { id }
      title
      url(transform: {
        width: 550,
        format: JPG,
        quality: 90
      })
    }
  }
  videoGtmClass
  galleryCollection(limit: 12) {
    total
    items {
      ... on GalleryBlockMedia {
        sys { id }
        title
        slug
        showTitle
        secondaryText
        image {
          sys { id }
          title
          thumbnail: url(transform: {
            width: 240,
            format: JPG,
            quality: 90
          })
          large: url(transform: {
            width: 1000,
            format: JPG,
            quality: 90
          })
          width
          height
          url
        }
        secondaryImage
        video
        videoCard {
          title
          slug
          copy
          video
          thumbnail {
            sys { id }
            title
            url(transform: {
              width: 550,
              format: JPG,
              quality: 90
            })
          }
        }
        videoGtmClass
        audio {
          sys { id }
          title
          description
          url
          contentType
        }
        audioGtmClass
      }
      ... on GalleryBlockText {
        sys { id }
        title
        slug
        showTitle
        copy { json }
        isQuote
        attribution
      }
    }
  }
  carousel {
    itemsCollection(limit: 12) {
      total
      items {
        sys { id }
        title
        copy
        expandButtonGtmClass
        thumbnail {
          title
          url(transform: {
            width: 628,
            height: 420,
            resizeStrategy: THUMB,
            resizeFocus: CENTER,
            format: JPG,
            quality: 90
          }) 
        }
      }
    }
  }
}
`
